import { CreateCheckoutSessionDefinition } from "@super-real/types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const createCheckoutSessionCallable = getCallable(
  CreateCheckoutSessionDefinition
);
